import { tns } from "tiny-slider/src/tiny-slider"

document.addEventListener('DOMContentLoaded', function() {

    const slideshowHeaderTop = document.querySelector(".headerTopBarSlide");

    if (slideshowHeaderTop) {
        tns({
            container: '.headerTopBarSlide',
            items: 1,
            gutter: 0,
            controls: false,
            nav: false,
            autoplay: true,
            autoplayButtonOutput: false,
            loop: true,
            mode: 'gallery',
            animateIn: 'tns-fadeIn',
            animateOut: 'tns-fadeOut',
            animateDelay: 2000,
            lazyload: true,
            lazyloadSelector: '.tns-lazy'
        });
    }

    const slideshowInEvidenza = document.querySelector(".inEvidenzaSlide");
    if (slideshowInEvidenza) {
        tns({
            container: '.inEvidenzaSlide',
            items: 1,
            gutter: 10,
            controls: false,
            nav: false,
            autoplay: true,
            touch: false,
            mouseDrag: false,
            autoplayButtonOutput: false,
            loop: true,
            lazyload: true,
            lazyloadSelector: '.tns-lazy'
        });
    }

    const slideshowCatalogoCategorie = document.querySelector(".catalogoCategorieSlide");
    if (slideshowCatalogoCategorie) {
        tns({
            container: '.catalogoCategorieSlide',
            items: 4,
            gutter: 10,
            nav: false,
            controls: true,
            controlsPosition: 'bottom',
            controlsText: ['<i class="fal fa-long-arrow-left text-isfor-blue text-4xl mr-4 mt-4"></i>', '<i class="fal fa-long-arrow-right text-isfor-blue text-4xl ml-4 mt-4"></i>'],
            autoplay: false,
            autoplayButtonOutput: false,
            loop: true,
            lazyload: true,
            lazyloadSelector: '.tns-lazy',
            responsive: {
                320: {
                    items: 2
                },
                640: {
                    items: 3
                },
                1024: {
                    items: 4
                }
            }
        });
    }

    const slideshowDocenti = document.querySelector(".docentiSlide");
    if (slideshowDocenti) {
        tns({
            container: '.docentiSlide',
            items: 1,
            gutter: 0,
            controls: false,
            nav: true,
            autoplay: true,
            autoplayButtonOutput: false,
            loop: true,
            lazyload: true,
            lazyloadSelector: '.tns-lazy'
        });
    }

    const slideshowAziende = document.querySelector(".aziendeSlide");
    if (slideshowAziende) {
        tns({
            container: '.aziendeSlide',
            items: 5,
            controls: true,
            controlsPosition: 'bottom',
            controlsText: ['<i class="fal fa-long-arrow-left text-isfor-blue text-4xl mr-4 mt-4"></i>', '<i class="fal fa-long-arrow-right text-isfor-blue text-4xl ml-4 mt-4"></i>'],
            nav: false,
            autoplay: false,
            autoplayButtonOutput: false,
            loop: true,
            lazyload: true,
            lazyloadSelector: '.tns-lazy',
            responsive: {
                320: {
                    items: 2,
                    gutter: 10,
                },
                640: {
                    items: 3
                },
                1024: {
                    items: 5
                }
            }
        });
    }

    const slideshowStoria = document.querySelector(".storiaSlide");
    let ss = null;
    if (slideshowStoria) {
        ss = tns({
            container: '.storiaSlide',
            items: 2.6,
            gutter: 10,
            edgePadding: 30,
            controls: true,
            controlsPosition: 'bottom',
            controlsText: ['<i class="far fa-long-arrow-left text-5xl fhd:text-8xl mr-4 mt-4"></i>', '<i class="far fa-long-arrow-right text-5xl fhd:text-8xl ml-4 mt-4 mr-8 sm:mr-0"></i>'],
            autoWidth: false,
            loop: false,
            swipeAngle: false,
            responsive: {
                0: {
                    items: 1
                },
                576: {
                    items: 2
                },
                1620: {
                    items: 2.6
                }
            }
        });

        ss.events.on('indexChanged', function () {
            let { index } = ss.getInfo();
            console.log(index + 1);

            let bollino = document.querySelectorAll(".bollino");
            let bollinoIndex = document.querySelector('#index' + index).querySelector('.bollino');
            let box = document.querySelector('#box' + index);
            let bollino2 = document.querySelector(".bollino2");
            let bollino2a = document.querySelector('#index' + index).querySelector('.bollino2');
            let slideItem = document.querySelectorAll(".slide-item");

            bollino ? bollino.forEach(item => { item.classList.remove("selected") }) : '';
            bollino2 ? bollino2.classList.add("selected") : '';
            bollinoIndex ? bollinoIndex.classList.add("selected") : '';
            slideItem ? slideItem.forEach(item => { item.classList.remove("selected") })  : '';
            box ? box.classList.add("selected") : '';
            bollino2a ? bollino2a.classList.remove("selected") : '';

        });
    }

    const dotsStoria = document.querySelectorAll(".goToSlide");
    if (dotsStoria) {
        for (let dot of dotsStoria) {
            dot.addEventListener("click", (e) => {
                let idSlide = e.target.parentNode.id.replace('index', '');
                //console.log(e.target.id);
                ss.goTo(idSlide);
            });
        }
    }
});